// src/services/users.js
import { api } from "./auth";

/**
 * 목록 조회 (검색/페이지네이션)
 * GET /users/?q=&page=&page_size=
 * 리다이렉트(307) 방지 위해 끝에 슬래시 사용
 */
export async function listUsers({ q = "", approval_status, page = 1, page_size = 10 } = {}) {
  const params = { q, page, page_size };
  if (approval_status) params.approval_status = approval_status;
  const { data } = await api.get("/users/", { params });
  return data; // { items, total }
}

/** 활성/비활성 토글 */
export async function toggleActive(id, is_active) {
  const { data } = await api.patch(`/users/${id}`, { is_active });
  return data;
}

/** 권한 변경 */
export async function updateRole(id, role) {
  const { data } = await api.patch(`/users/${id}`, { role });
  return data;
}

/** 사용자 삭제 */
export async function removeUser(id) {
  const { data } = await api.delete(`/users/${id}`);
  return data;
}

export async function approveUser(id) {
  const { data } = await api.patch(`/users/${id}/approval`, { status: "APPROVED" });
  return data;
}

export async function rejectUser(id, reason) {
  const { data } = await api.patch(`/users/${id}/approval`, { status: "REJECTED", reason });
  return data;
}
